import { motion } from 'framer-motion';

const steps = [
  {
    numeral: 'i · Speak',
    title: 'A voice guides you',
    description:
      'You close your eyes and step into the white room. One by one you describe what appears: a cube, a ladder, a horse, flowers, a storm. There are no wrong answers.',
  },
  {
    numeral: 'ii · The reading',
    title: 'Your words are weighed',
    description:
      'The AI listens the way the psychiatrist learned to in a thousand conversations: not to what you imagine, but to how you imagine it.',
  },
  {
    numeral: 'iii · Your portrait',
    title: 'A mirror, in writing',
    description:
      'You get a personal portrait of how you see yourself, your ambitions, the people around you, and the storms you expect.',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 border-t border-[#e4e1d8]">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-10"
        >
          <h2 className="font-serif font-medium text-3xl sm:text-4xl text-[#1d1f24] mb-3">How it works</h2>
          <p className="text-lg text-[#5d606a] max-w-2xl">
            The cube test is a projective test: you describe an imagined room, and the way you describe it describes you.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white border border-[#e4e1d8] rounded-xl p-7 shadow-[0_10px_24px_rgba(29,31,36,0.05)]"
            >
              <div className="font-serif italic text-[#c43b3b] text-lg">{step.numeral}</div>
              <h3 className="font-serif text-xl text-[#1d1f24] mt-2 mb-2.5">{step.title}</h3>
              <p className="text-sm text-[#5d606a] leading-relaxed">{step.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center mt-10 text-[#5d606a]"
        >
          Average completion time: <span className="text-[#1d1f24] font-semibold">5 minutes</span>
        </motion.p>
      </div>
    </section>
  );
}
